require.register("app/restaurant/stat/ProductVolumeRankView", function(exports, require, module){
  $0
  
});

